import $ from 'jquery';

import { get, post } from 'modules/api';
import jqueryToPromise from 'modules/utils/jqueryToPromise';

export const fetchOrders = () => get('orders/');

export const fetchOrdersImpact = orderId => get(`orders/${orderId}/impact`);

export const sendDelivery = (basketId, payload) => post(`orders/${basketId}/delivery`, payload);

export const fetchOrderDetails = orderId => get(`orders/${orderId}/details`);

export const cancelOrder = (orderId, { cancellationReason }) =>
    post(`orders/${orderId}/cancel`, { cancellationReason });

export const resetToCart = orderId => post(`orders/${orderId}/reset-to-cart`);

export const postRepayOrder = paymentUuid =>
    jqueryToPromise($.post(`${process.env.API_ROOT}/orders/repay/${paymentUuid}`));
